import _ from '../../common/utility';

function partnerTwoCol() {

	try {
		if (typeof qrllog != 'undefined' && qrllog == "1") {
			$('body').addClass('logged-in');
		}
		else if (typeof qrllog != 'undefined' && qrllog == "0") {
			$('body').addClass('logged-out');
		}
	}
	catch(e) {
		console.log(e);
	}

	if (typeof window.ontouchstart != 'undefined') {
		$('body').addClass('is-touch');
		if (navigator.userAgent.indexOf('iPad') != -1) {
			$('body').addClass('is-ipad');
		} else {
			$('body').addClass('not-ipad');
		}
	} else {
		$('body').addClass('is-desktop');
		$('body').addClass('not-ipad');
	}

	$('.subsection-container').each(function() {
		if ($(this).siblings().length == 0) {
			var moreLink = $(this).find('.more');
			if ((moreLink.length > 0 && moreLink.siblings().length == 0 && $.trim(moreLink.parent()[0].innerText.replace(moreLink[0].innerText,'')) == '' && moreLink.parent().siblings().length == 0) || ($(this).children().length == 1 && $(this).children('ul').length == 1)) {
				$(this).parent().prev().addClass('no-border');
			}
		}
	});

	$('.no-byline').each(function() {
		$(this).parents('.subsection:eq(0)').addClass('no-byline');
	});

	$('.no-teaser').each(function() {
		$(this).parents('.subsection:eq(0)').addClass('no-teaser');
	});
	
	$('.no-border').each(function() {
		$(this).parents('.subsection:eq(0)').addClass('no-border');
	});
	
	$('.four-horizontal').each(function() {
		if (this.tagName.toLowerCase() != 'ul') {
			$(this).removeClass('four-horizontal');
		}
		$(this).parents('.subsection:eq(0)').find('ul').addClass('four-horizontal');
	});
	
	$('.headshot').each(function() {
		$(this).parent().addClass('float-parent');
	});
	
	$(document).one('ready', function () {
		setTimeout(function() {
			$('.hp_rightcol .AdUnit[style*="display: none"], .hp_rightcol .blank-ad').parents('.subsection:eq(0)').hide();
		}, 2000);
		setTimeout(function() {
			$('.hp_rightcol .AdUnit[style*="display: none"], .hp_rightcol .blank-ad').parents('.subsection:eq(0)').hide();
		}, 5000);
	});
}

export default _.catch(partnerTwoCol);